import { path, pathOr } from 'ramda';
import { useQueryApplication } from 'src/graphqlhooks';
import { mkObjectForLoanRole } from '../objects/build';
import { validateSchema } from 'src/services';
import { mutateEventSchema } from './schema/events.schema';
import { isNotEmpty } from 'src/utilities/hasValue';
import { STATUS_PENDING } from '../constants';


export const CREATE_EVENTS = `mutation createEvents($data: [events_insert_input!]!) {
    insert_events(objects: $data) {
      returning {
        id,
        object_meta,
        type_meta,
        payload_raw
        source_provider
        source
        action
        payload_data
        triggered_by
        created_at
        updated_at
        status
      }
    }
  }`;

export interface EventDetails {
  source: string;
  action: string;
  source_provider: string;
  payload_raw?: string;
  payload_data?: string;
  triggered_by?: string;
}

export const mkEvent = (
  data: EventDetails
) => {
  const source = path(['source'], data)
  const action = path(['action'], data)
  return {
    object_meta: mkObjectForLoanRole(`event-${source}-${action}`),
    source: source,
    action: action,
    source_provider: path(['source_provider'], data),
    payload_raw: pathOr('', ['payload_raw'], data),
    payload_data: pathOr('', ['payload_data'], data),
    triggered_by: pathOr('', ['triggered_by'], data),
    created_at: 'now()',
    updated_at: 'now()',
    status: {
      phase: STATUS_PENDING,
    }
  }
}

export const gqlCreateEvent = (event: any) => {
  const error = validateSchema(event, mutateEventSchema);
  if (isNotEmpty(error)) {
    return { error: pathOr({}, [0], error), loading: false };
  }
  const { data, loading } = useQueryApplication(CREATE_EVENTS, {
    variables: { data: [event] },
  });
  return { data, loading };
};
